import { graphql } from 'gatsby';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next/dist';
import React, { useEffect } from 'react';
import Header from '../components/HeaderDynamicPages/Header';
import Layout from '../components/Layout/Layout';
import SecondHandMachinesPage from '../components/SecondHandMachinesPage/SecondHandMachinesPage';
import PrinterWrapper from '../components/PrintWrapper/PrintWrapper';
import { staticPageRedirection } from '../utils/staticPagesRedirection';
import { SECOND_HAND_MACHINES_DE_LANGUAGES } from '../constants/sitesLanguagesGroup';
import Alternate from '../components/Seo/Alternate';
import { prepareAlternateData } from '../utils/prepareAlternateData';
import { dataToBreadcrumbsFromNav } from '../utils/dataToBreadCrumbsFromNav';
import secondHandMachinesTranslations from '../JSON/StaticSitesTranslations/secondHandMachinesTranslations.json';

const SecondHandMachines = ({
    data: {
        drupal: {
            used_machines: { data: usedMachinesData },
        },
    },
}) => {
    const { language } = useI18next();
    const languagesWithUrls = [];
    const { category, categoryItem, item } = dataToBreadcrumbsFromNav(language, 'gebraucht-mietmaschinen');
    process.env.LANGUAGES.split(',').forEach((language: string) =>
        languagesWithUrls.push(prepareAlternateData(language, 'secondHandMachines'))
    );

    useEffect(() => {
        staticPageRedirection(language, 'secondHandMachines', SECOND_HAND_MACHINES_DE_LANGUAGES);
    }, []);

    return (
        <Layout
            title={'BOGE | Miet- und Gebrauchtmaschinen | Druckluft'}
            description={
                'Möchten Sie einen gebrauchten Druckluft Kompressor mieten oder einfach online kaufen? Erfahren Sie mehr über die Gebrauchtmaschinen und Mietkompressoren von BOGE.'
            }
            languageVersionsUrl={secondHandMachinesTranslations}
        >
            <Alternate languages={languagesWithUrls} />
            <Header category={category} categoryItem={categoryItem} item={item} />
            <PrinterWrapper isShmPage={true}>
                <SecondHandMachinesPage usedMachinesData={usedMachinesData} />
            </PrinterWrapper>
        </Layout>
    );
};

export default SecondHandMachines;

export const query = graphql`
    query ($language: String!) {
        drupal {
            used_machines {
                data
            }
        }
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
    }
`;
